export default "__VITE_ASSET__0d6b847a__"